import { Capacitor } from '@capacitor/core';
import { Camera, MediaTypeSelection } from '@capacitor/camera';

// Dentro da app (Capacitor) a câmara e a galeria são nativas; no browser mantém-se o <input type="file">
export const isAppNativa = Capacitor.isNativePlatform();

// Pedimos ao sistema JPEG até 1600px (HEIC convertido, rotação corrigida). Na selecção múltipla do Android
// o plugin devolve os originais, por isso o upload volta sempre a comprimir no browser.
const LADO_MAX_PX = 1600;
const QUALIDADE_JPEG = 70;
const MAX_FOTOS_POR_SELECCAO = 45;
const MAX_VIDEOS_POR_SELECCAO = 10;

// O utilizador fechou a câmara/galeria sem escolher: não é um erro a mostrar
export const isCancelamento = (error) => /cancel/i.test(error?.message || '');

async function paraFicheiro(resultado, nomeBase) {
    const resposta = await fetch(resultado.webPath);
    const blob = await resposta.blob();
    const tipo = blob.type || 'application/octet-stream';
    const extensao = tipo === 'image/jpeg' ? 'jpg' : (tipo.split('/')[1] || 'bin');
    return new File([blob], `${nomeBase}.${extensao}`, { type: tipo });
}

const opcoesFoto = {
    quality: QUALIDADE_JPEG,
    targetWidth: LADO_MAX_PX,
    targetHeight: LADO_MAX_PX,
    correctOrientation: true,
};

export async function tirarFoto() {
    const resultado = await Camera.takePhoto({ ...opcoesFoto, saveToGallery: false });
    return paraFicheiro(resultado, `foto-${Date.now()}`);
}

export async function escolherFotosDaGaleria() {
    const { results } = await Camera.chooseFromGallery({
        ...opcoesFoto,
        mediaType: MediaTypeSelection.Photo,
        allowMultipleSelection: true,
        limit: MAX_FOTOS_POR_SELECCAO,
    });
    const instante = Date.now();
    return Promise.all(results.map((resultado, i) => paraFicheiro(resultado, `foto-${instante}-${i}`)));
}

export async function escolherVideosDaGaleria() {
    const { results } = await Camera.chooseFromGallery({
        mediaType: MediaTypeSelection.Video,
        allowMultipleSelection: true,
        limit: MAX_VIDEOS_POR_SELECCAO,
    });
    const instante = Date.now();
    return Promise.all(results.map((resultado, i) => paraFicheiro(resultado, `video-${instante}-${i}`)));
}
